import { apiService } from './api-service';

export const validationService = {

  validateManualAddressLine1: (value) => {
    return value ? null : 'Address line 1 is required'
  },

  validateManualAddressTown: (value) => {
    return value ? null : 'Town is required'
  },

  validatePostcode: async (
    postcode,
    disableNorthernIrelandPostcodes = false
  ) => {
    if (!postcode) {
      return 'Postcode required';
    }
    const postcodeRegex = /^(GIR ?0AA|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]([0-9ABEHMNPRV-Y])?)|[0-9][A-HJKPS-UW]) ?[0-9][ABD-HJLNP-UW-Z]{2})$/;
    const isValid = postcodeRegex.test(postcode.toUpperCase().replace(/ /g, ''));
    if (!isValid) {
      return 'Sorry, this is not a valid postcode';
    }
    const postcodeNIRegex = /^BT.*$/;
    const isNIPostcode = postcodeNIRegex.test(postcode);
    if (disableNorthernIrelandPostcodes && isNIPostcode) {
      return `Sorry, we don't currently offer our service in Northern Ireland.`;
    }
    try {
      const response = await apiService.validatePostcode(postcode);
      return response.isValid
        ? null
        : 'Sorry, this postcode is not recognised';
    } catch (error) {
      return null;
    }
  }

};
